import Vue from 'vue'
import Vuex from 'vuex'
import vuexPersistedStatePlugin from 'vuex-persistedstate'
import center from '@/store/center'
import user from '@/store/user'
import order from '@/store/order'
import project from '@/store/project'
import team from '@/store/team'
import Cookies from 'js-cookie'

// vuex+storage: https://github.com/robinvdvleuten/vuex-persistedstate
Vue.use(Vuex)
export default new Vuex.Store({
  strict: process.env.NODE_ENV !== 'production',
  state: {
    keepAlive: ['productList', 'order', 'cardList', 'newsList', 'consultList'], //缓存 ['productList', 'order']
    sid: '00-0',
    initializeSid: '',
    showBanner: true,
    teamillnessCode: {id: '', code: ''},
    serverCardMsg: {},
    serverCardData: {},
    quickAppointmentTime: {},
    xyszOrderTime: {},
    quickAppointment: '',
    APIUrl:window.location.protocol + '//' + window.location.host,
    webContentUrl:window.location.protocol + '//' + window.location.host+'/m',
    wxContentUrl:window.location.protocol + '//' + window.location.host+'/wx',
    imageResourcesUrl: process.env.VUE_APP_STATIC_RESOURCES_URL,
    staticResourcesUrl: process.env.VUE_APP_IMAGE_RESOURCES_URL
  },
  mutations: {
    setInitializeSid (state, data) {
      Cookies.set('51jk._originalSid', data)
      state.initializeSid = data
    },
    setxyszOrderTime (state, data) {
      state.xyszOrderTime = data
    },
    setQuickAppointmentTime (state, data) {
      state.quickAppointmentTime = data
    },
    setQuickAppointment (state, data) {
      state.quickAppointment = data
    },
    closeBanner (state) {
      state.showBanner = false
    },
    setSID (state, data) {
      state.sid = data
    },
    setTeamillnessCode (state, data) {
      state.teamillnessCode = data
    },
    setKeepAlive (state, data) {
      state.keepAlive = data
    },
    setServerCardMsg (state, data) {
      state.serverCardMsg = data
    },
    setServerCardData (state, data) {
      state.serverCardData = data
    }
  },
  actions: {},
  modules: {
    center,
    user,
    project,
    order,
    team
  },
  plugins: [vuexPersistedStatePlugin({
    key: '51jk.cache',
    paths: ['showBanner', 'center', 'order', 'sid', 'initializeSid', 'user', 'serverCardMsg', 'serverCardData'],
    storage: window.sessionStorage
  }), vuexPersistedStatePlugin({
    key: '51jk.project',
    paths: ['project'],
    storage: window.sessionStorage
  }), vuexPersistedStatePlugin({
    key: '51jk.team',
    paths: ['team'],
    storage: window.sessionStorage
  })]
})
